<template>
  <div class="home">
    <div
      class="hero"
      :style="{
        backgroundImage: `url(${config.FEATURE_TOP_HERO_BACKGROUND_URL})`,
      }"
    >
      <div class="dark"></div>
      <div class="contain">
        <h1>COVID-19pad, keeping everyone safe.</h1>
      </div>
    </div>

    <div class='contain'>
        <p class='big'>Popshap COVID19pad Platform is built to help businesses to make sure that their workplace is a safe place to come back to. As new health and safety policies are created to ensure Employers and Employees will rightly want to know how they will be protected.</p>
    </div>

    <div class='facts'>
        <div class='contain'>
            <h2>COVID19pad is here to help you protect your employees and customers.</h2>
            <div class='checkmarks'>
                <p><img src='@/assets/img/checkmark.svg'> Create and customize surveys</p>
                <p><img src='@/assets/img/checkmark.svg'> Send QR Code confirmation if SAFE to show up</p>
                <p><img src='@/assets/img/checkmark.svg'> Control and Schedule Survey Distribution</p>
                <p><img src='@/assets/img/checkmark.svg'> Notify employees and visitors through emails or SMS</p>
                <p><img src='@/assets/img/checkmark.svg'> Connect to HR system if required through API</p>
                <p><img src='@/assets/img/checkmark.svg'> Keep track and create reports</p>
            </div>
        </div>
    </div>

    <div class='contain img-text-intro'>
        <h2>COVID-19 Employers Survey System</h2>
        <p class='mid'>Employers are allowed to ask about coronavirus-related symptoms and take the temperatures of employees under guidance from the Equal Employment Opportunity Commission (EEOC), and some states now require it.</p>
    </div>

    <div class="img-text right">
      <div class="contain">
        <div class="text">
          <h2>Customize any survey form.</h2>
          <p>
            Create the questions based on your State & Company guide lines, available for multi-locations as well.
          </p>
          <div class="btns">
            <button @click="$router.push({ path: '/register' })" class="btn">
              Get Started
            </button>
          </div>
        </div>
        <div>
          <img
            :src="config.FEATURE_LAPTOP_IMAGE_1"
          />
        </div>
      </div>
    </div>

    <div class="img-text color">
      <div class="contain">
        <div class="text">
          <h2>Schedule and send in bulk.</h2>
          <p>
            One click send function to all your employees or visitors, Create a repeat sending schedule.
          </p>
          <div class="btns">
            <button @click="$router.push({ path: '/register' })" class="btn">
              Get Started
            </button>
          </div>
        </div>
        <div>
          <img
            :src="config.FEATURE_DESKTOP_IMAGE"
          />
        </div>
      </div>
    </div>

    <div class="img-text right">
      <div class="contain">
        <div class="text">
          <h2>Keep track with reports.</h2>
          <p>
            Ability to track which employees didn t fill in the questionnaire and overall usage reports.
          </p>
          <div class="btns">
            <button @click="$router.push({ path: '/register' })" class="btn">
              Get Started
            </button>
          </div>
        </div>
        <div>
          <img
            :src="config.FEATURE_LAPTOP_IMAGE_2"
          />
        </div>
      </div>
    </div>

    <div class='full-img' :style="{backgroundImage: `url(${config.FEATURE_BOTTOM_HERO_BACKGROUND_URL})`}"></div>

    <foot></foot>
  </div>
</template>

<script>
import Footer from "@/components/Footer";
import firebase from "firebase";
import axios from "axios";
import Swal from "sweetalert2";

const fb = require("../firebaseConfig.js");
const db = fb.default.db;
const functions = fb.default.functions;

export default {
  name: "home",
  components: {
    foot: Footer,
  },
  data() {
    return {
      user: {
        first_name: null,
        last_name: null,
        email: null,
        phone: null,
        comments: null,
      },
      contact: {
        first_name: null,
        last_name: null,
        email: null,
        phone: null,
        comments: null,
      },
      status: "submit",
      feedback: "",
      sendEmail: functions.httpsCallable("sendEmail"),
    };
  },
  mounted() {},
  async created() {
    await this.getAffiliates();
  },
  updated() {},
  methods: {
    validate() {
      let valid = true;
      let contact = this.contact;

      for (let key in contact) {
        if (!contact[key]) valid = false;
      }

      if (valid) {
        this.sendContact();
      } else {
        this.feedback = "Please enter all required fields";
      }
    },
    sendContact() {
      this.status = null;
      this.feedback = null;
      this.sendEmail({
        template_name: "covid-19-send-contact",
        to_email: [
          {
            email: "eitan@emagid.com",
            type: "to",
          },
        ],
        from_email: null,
        global_merge_vars: [
          {
            name: "name",
            content: this.contact.first_name + " " + this.contact.last_name,
          },
          {
            name: "email",
            content: this.contact.email,
          },
          {
            name: "phone",
            content: this.contact.phone,
          },
          {
            name: "comments",
            content: this.contact.comment,
          },
        ],
        message: null,
      })
        .then((response) => {
          setTimeout(() => {
            this.status = "success";
            this.contact = {
              first_name: null,
              last_name: null,
              email: null,
              phone: null,
              comments: null,
            };
          }, 500);
        })
        .catch(function(error) {
          console.log(error);
          Swal.fire("Could not send email");
        });
    },
  },
};
</script>

<style scoped lang="scss">
  .img-text {
    img {
      max-width: 575px;
      @media screen and (max-width: 1100px) {
        max-width: 350px;
      }
      @media screen and (max-width: 900px) {
        max-width: 400px;
        width: 100%;
      }
    }
}
</style>
